// extracted by mini-css-extract-plugin
export default {"details_big_banner":"style_details_big_banner__kdcdc","details_big_banner_loader":"style_details_big_banner_loader__BNCy5"};